import React, {
    useEffect,
    useRef,
} from 'react';
import _get from 'lodash/get';
import _noop from 'lodash/noop';
import PropTypes from 'prop-types';
import {
    MediaPlayerWrapper,
    useWindowDimensions,
} from 'web-media-ui-component';
import PlayerUtils from 'utils/player-utils';

const PlaybackPagePlayer = ({
    container,
    mediaConfig,
    clientSideReady,
    clipData,
    list,
    club,
    isClubPage,
    topicId,
    lang,
    onNextClipDataLoaded,
    onAdStartedEvent,
    deviceInfo,
    mbox,
}) => {

    if(!clientSideReady) {

        return null;

    }

    const { width } = useWindowDimensions();
    const LARGE_BP = 1024;
    const isLargeBp = useRef(false);
    const subscriptions = useRef([]);

    useEffect(() => {

        return (() => {

            PlayerUtils.unsubscribeFromSubscriptions(subscriptions.current);

        });

    }, []);

    useEffect(() => {

        isLargeBp.current = width >= LARGE_BP;

    }, [width]);

    const playerTypeConfig = _get(mediaConfig, 'playerTypeConfig');
    const autoPlay = _get(playerTypeConfig, 'autoplay', true);
    const mute = _get(playerTypeConfig, 'mute', false);

    return (
        <MediaPlayerWrapper
            container={container}
            fullscreenElementId={container}
            mediaConfig={mediaConfig}
            metaData={clipData}
            list={list}
            autoPlay={autoPlay}
            mute={mute}
            leaveBehindEnabled={true}
            countdown={3}
            onPlayerLoaded={(embedWrapper) => {

                return PlayerUtils.onPlayerLoadedHandler(embedWrapper, clipData, onNextClipDataLoaded, onAdStartedEvent).then((playerSubscriptions) => {

                    subscriptions.current = playerSubscriptions;
                    return;

                });

            }}
            club={club}
            isClubPage={isClubPage}
            lang={lang}
            topicId={topicId}
            dynamicAdConfig={{
                buildAdConfig: {
                    enabled: false
                },
                customAdRequestBuilder: (config, clip, cuePointVO) => {

                    return PlayerUtils.customAdRequestBuilder(config, clip, cuePointVO, isLargeBp.current, isClubPage, topicId, mbox);

                },
            }}
            deviceInfo={deviceInfo}
            deviceFormFactor={_get(deviceInfo, 'formFactor')}
            mbox={mbox}
        />
    );

};

PlaybackPagePlayer.propTypes = {
    container: PropTypes.string.isRequired,
    mediaConfig: PropTypes.object.isRequired,
    clipData: PropTypes.object.isRequired,
    list: PropTypes.array.isRequired,
    clientSideReady: PropTypes.bool.isRequired,
    club: PropTypes.string.isRequired,
    isClubPage: PropTypes.bool.isRequired,
    lang: PropTypes.string.isRequired,
    topicId: PropTypes.string.isRequired,
    deviceInfo: PropTypes.shape().isRequired,
    onNextClipDataLoaded: PropTypes.func,
    onAdStartedEvent: PropTypes.func,
    mbox: PropTypes.object
};

PlaybackPagePlayer.defaultProps = {
    container: '',
    mediaConfig: {},
    clipData: {},
    list: [],
    onNextClipDataLoaded: _noop,
    onAdStartedEvent: _noop,
};

export default PlaybackPagePlayer;
